import React from "react";
import {CardTag} from "../styles";
import {FITS_ON_LOT_TAG_TEXT} from "../../../../../_shared/constants/labels";

export const FitsOnLotTag: React.FC = () => {
  return <CardTag key={`fits-on-lot-tag`}>{FITS_ON_LOT_TAG_TEXT}</CardTag>;
};
